import AwardsCategoryData from './AwardsCategoryData';
import AwardsData from './AwardsData';
import AwardsOfficeData from './AwardsOfficeData';
import AwardsRegionData from './AwardsRegionData';
import AwardsWinnerData from './AwardsWinnerData';
import AwardsWinnerWithPointsData from './AwardsWinnerWithPointsData';
import ClientFilterStore from './filters/client/ClientFilterStore';
import FilterForm from './filters/FilterForm';

class AwardsResult {
  /**
   *
   * @type {AwardsData | AwardsRegionData | AwardsOfficeData} 
   */
  awardsData = null;

  /**
   *
   * @type {FilterForm}
   */
  filterForm = null;

  constructor(data) {
    this.buildAwardData(data);
    data?.filterForm && this.buildFilterForm(data);
  }

  buildAwardData(data) {
    const {
      awardsData, 
      resultTotals, 
      awardResultType, 
      awardNamesByPriority, 
    } = data;
    const normalizedType = awardResultType?.toLowerCase?.() || 'region';

    const awardTypeMap = {
      office: {
        ClassName: AwardsOfficeData,
      },
      region: {
        ClassName: AwardsRegionData,
      },
      category: {
        ClassName: AwardsCategoryData,
      },
      winner: {
        ClassName: AwardsWinnerData,
      },
      winnerwithpoints: {
        ClassName: AwardsWinnerWithPointsData,
      },
    };

    const { ClassName } = awardTypeMap[normalizedType] || awardTypeMap['region'];
    this.awardsData = new ClassName(awardsData, resultTotals, awardNamesByPriority);
    
    console.log('buildAwardData');
    console.log(this.awardsData);
  }

  buildFilterForm(data) {
    const { filterForm } = data;
    // this.filterForm = new FilterForm(filterForm);
    this.filterForm = new ClientFilterStore(filterForm);
  }

  updateAwardData(awardData) {
    this.awardsData = awardData.awardsData;
  }
}

export default AwardsResult;
